import { LOAN_REQUEST_OFFER_STATUS } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    id: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetAcceptedOfferCounts = z.record(
    z.nativeEnum(LOAN_REQUEST_OFFER_STATUS),
    z.number(),
);

export type SchemaLoanRequestResolver_GetAcceptedOfferCounts = z.infer<
    typeof schemaLoanRequestResolver_GetAcceptedOfferCounts
>;

export type LoanRequestResolver_GetAcceptedOfferCounts = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetAcceptedOfferCounts
>;
